export default {
    colors: {
        default: '#344675',
        primary: 'var(--primary-color)',
        info: '#2675ff',
        danger: '#d93346',
        orange: '#ff8a76',
        teal: '#00d6b4',
        success: '#00f2c3',
        gray: '#899398',
        light_gray: '#bfc5d0',
        warm_grey: '#9b9b9b',
        charcoal_grey: '#2a2c36',
        light_green: '#5EB300',
    },
    fields: {
        jitter: {
            min: 0,
            max: 20,
        },
        mos: {
            min: 0,
            max: 4.15,
        },
        packetLoss: {
            min: 0,
            max: 20,
        },
    },
    fonts: {
        base: 'var(--font-size-base)',
    },
}
